module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.message.length) ? _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.message))])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c5406932", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5406932"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer/classMessage.vue
// module id = 396
// module chunks = 6